<section auto-size-columns>
	<text-group>
		<span>{{ 'order-details.popup-commission.yearly-value-for-new-plans' | translate }}</span>
		<span align-right>{{ newPlansAnnualValueForRenewal | currency }}</span>

		<span>{{ 'order-details.popup-commission.yearly-value-for-old-plans' | translate }}</span>
		<span align-right>{{ discontinuedPlansAnnualValueForRenewal | currency }}</span>

		<span>{{ 'order-details.popup-commission.adjustment-amount' | translate }}</span>
		<span align-right>{{ getTotalAdjustmentAmount() + (hasExternalAdjustments() ? totalDiscount : 0) | currency }}</span>

		<span>{{ 'order-details.popup-commission.remaining-value' | translate }}</span>
		<span align-right>{{ calculateSupersededRemainingAmountForOrder() | currency }}</span>

		<spacer />

		<span>{{ 'order-details.popup-commission.no-period-products-total' | translate }}</span>
		<span align-right>{{ sumOfProductsWithNoPeriod | currency }}</span>

		<span>{{ 'order-details.popup-commission.renewable-commissionable-products-total' | translate }}</span>
		<span align-right>{{ sumOfRenewableCommissionableProducts | currency }}</span>

		<span bold>{{ 'order-details.popup-commission.commissionable-products-total' | translate }}</span>
		<span bold align-right>{{ (getTotalPrice() - sumOfNonCommissionableProducts) | currency }}</span>
	</text-group>
</section>
@if (upfrontPaidOrder) {
	<section>
		<p>{{ 'order-details.popup-commission.upfront-paid-order' | translate }}</p>
	</section>
}
@else {
	<section auto-size-columns>
		<div>
			<h3>{{ 'order-details.commission.acv-extend' | translate }}</h3>
			<p>{{ 'order-details.popup-commission.acv-extend-calculation' | translate }}</p>
		</div>
		<text-group>
			<span>{{ maxNewPeriodInYears }} * {{ discontinuedPlansAnnualValueForRenewal | currency }} - {{ math.abs(getTotalAdjustmentAmount() + (hasExternalAdjustments() ? totalDiscount : 0)) | currency }} - {{ math.abs(calculateSupersededRemainingAmountForOrder()) | currency }}</span>
			<span align-right>{{ acvExtend | currency }}</span>
		</text-group>
		@if (warningAcvExtendNegativeThereforeZero) {
			<p>{{ 'order-details.popup-commission.acv-extend-negative-therefore-0' | translate: {acvExtendValue: (acvExtend | currency)} }}</p>
		}
	</section>
	<section auto-size-columns>
		<div>
			<h3>{{ 'order-details.commission.acv-increase' | translate }}</h3>
			<p>{{ 'order-details.popup-commission.acv-increase-calculation' | translate }}</p>
		</div>
		<text-group>
			<span>{{ this.sumOfRenewableCommissionableProducts | currency }} - {{ math.abs(getTotalAdjustmentAmount() + (hasExternalAdjustments() ? totalDiscount : 0)) | currency }} - {{ math.abs(calculateSupersededRemainingAmountForOrder()) | currency }} - {{ (acvExtend < 0 ? 0 : acvExtend) | currency }}</span>
			<span align-right>{{ acvIncrease | currency }}</span>
		</text-group>
	</section>
	@if (warningAcvIncreaseNegativeThereforeZero) {
		<section>
			<p>{{ 'order-details.popup-commission.acv-increase-negative-therefore-0' | translate: {acvIncreaseValue: (acvIncrease | currency), newAcvExtend: ((acvExtend + acvIncrease) | currency)} }}</p>
		</section>
	}
}
